function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("rect", {
  width: 42,
  height: 42,
  rx: 21,
  fill: "#FA6358",
  fillOpacity: 0.15
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M42.1 22.54l1.854-2.421c.553-.64.715-1.11.78-1.413-1.43.942-2.797 1.211-3.773 1.245h-.39l-.228-.27C39.17 18.606 37.707 18 36.113 18c-3.415 0-6.18 2.893-6.18 6.39 0 .27 0 .505.032.74l.163 1.043-1.041-.033c-6.344-.169-11.452-5.718-12.33-6.727-1.367 2.623-.618 5.011.26 6.525l1.66 2.859-2.636-1.48c.033 2.119.846 3.8 2.342 5.012l1.27 1.009-1.335.571c.846 2.624 2.668 3.667 4.1 4.07l1.789.505-1.562 1.11c-2.733 1.984-6.214 1.85-7.645 1.715C18.123 43.53 21.767 44 24.37 44c1.919 0 3.318-.27 3.675-.336C41.84 40.3 42.457 27.586 42.425 25.03v-.404l.293-.269c1.659-1.614 2.374-2.523 2.765-2.994-.163.101-.326.135-.553.202l-2.83.976z",
  fill: "#444"
});

function SvgTwitterinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 46 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2);
}

export default SvgTwitterinline;